<template>
  <div class="supplement-dashboard">
    <SupplementList
      :supplement-search-store="supplementSearchStore"
      :show-search="showSearch"
      :show-archive-filter="showArchiveFilter"
      :user-id="userId"
    />
  </div>
</template>

<script setup>import { computed as _computed } from 'vue';

  import SupplementList from "./supplement-list.vue";
  import { useSupplementSearchStore } from "./stores/supplement-search-store.js";
  import useViewLoadTracking from "./lib/use-view-load-tracking.js";
  import { filterSupplementLabelsPath } from "~/routes";
  import { onBeforeMount } from "vue";

  const props = defineProps({
    perPage: { type: Number, default: 10 },
    labelsCount: { type: Number, default: 0 },
    archivedLabelsCount: { type: Number, default: 0 },
    userId: { type: Number, default: null },
  });

  const supplementSearchStore = useSupplementSearchStore();

  useViewLoadTracking(() => supplementSearchStore.loaded);

  onBeforeMount(() => {
    supplementSearchStore.setSearchEndpoint(filterSupplementLabelsPath());
    supplementSearchStore.$patch({ perPage: props.perPage });
    if (props.userId) {
      supplementSearchStore.$patch({ userId: props.userId });
    }
    supplementSearchStore.loadInitial();
  });

  const showSearch = _computed(() =>
    Boolean(props.labelsCount > props.perPage || supplementSearchStore.hasQuery)
  );

  const showArchiveFilter = _computed(
    () => props.archivedLabelsCount > 0 || supplementSearchStore.archivedLabelsCount > 0
  );
</script>
